import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { MAX_ELEMENTS_RECENTS } from 'utils/constants';

const ITEM_RECENT_SEARCHES = 'itemsRecentSearches';

const actualizeLocalStorage = (recientes) => {
  localStorage.setItem(ITEM_RECENT_SEARCHES, JSON.stringify(recientes));
};

// Define the initial state using that type
const initialState: any = (function getItemsRecentsSearches() {
  return JSON.parse(localStorage.getItem(ITEM_RECENT_SEARCHES) || '[]');
})();

export const recentSearchsSlice = createSlice({
  name: 'recentSearchsSlice',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    updateRecentSearchs: (state, action) => {
      state.itemsRecentsSearches = action.payload;
      actualizeLocalStorage(state);
    },
    resetRecentSearchs: (state, action) => {
      state.itemsRecentsSearches = [];
      actualizeLocalStorage(state);
    },
    pushRecentSearch: (state, action) => {
      //TODO: gestionar busquedas recientes
      const existe = state.find(
        (element) => element.id === action.payload.id && element.type === action.payload.type,
      );
      if (!existe) {
        if (state.length >= MAX_ELEMENTS_RECENTS) {
          state.pop();
        }
        state.unshift(action.payload);
        actualizeLocalStorage(state);
      }
    },
  },
});

export const { updateRecentSearchs, resetRecentSearchs, pushRecentSearch } =
  recentSearchsSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const recentSearchsState = (state: RootState) => state.recentSearchs;

export default recentSearchsSlice.reducer;
